import { lazy } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// project imports
// import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import ClientFormSteps from 'views/admin-components/pages/admin-client-form/ClientFormSteps';
// import { Test } from 'views/admin-components/pages/Test';
// dashboard routing
// const DashboardDefault = Loadable(lazy(() => import('views/admin-components/dashboard/Default/TotalIncomeDarkCard')));

const MainLayout = Loadable(lazy(() => import('layout/MainLayout')));
const AssetCategories = Loadable(lazy(() => import('views/admin-components/pages/AssetCategories')));
const Test = Loadable(lazy(() => import('views/admin-components/pages/Test')));
const AssetCategory = Loadable(lazy(() => import('views/admin-components/pages/AssetCategory')));
const AssetClass = Loadable(lazy(() => import('views/admin-components/pages/AssetClass')));
const AssetClasses = Loadable(lazy(() => import('views/admin-components/pages/AssetClasses')));
const Securities = Loadable(lazy(() => import('views/admin-components/pages/Securities')));
const Security = Loadable(lazy(() => import('views/admin-components/pages/Security')));
const AddFunds = Loadable(lazy(() => import('views/admin-components/pages/AddFunds')));
const AddFund = Loadable(lazy(() => import('views/admin-components/pages/AddFund')));

const Advisors = Loadable(lazy(() => import('views/admin-components/pages/Advisors')));
const Advisor = Loadable(lazy(() => import('views/admin-components/pages/Advisor')));

const Benchmark = Loadable(lazy(() => import('views/admin-components/pages/Benchmark')));
const Benchmarks = Loadable(lazy(() => import('views/admin-components/pages/Benchmarks')));

const Enhancement = Loadable(lazy(() => import('views/admin-components/pages/Enhancement')));
const Enhancements = Loadable(lazy(() => import('views/admin-components/pages/Enhancements')));

const Partners = Loadable(lazy(() => import('views/admin-components/pages/Partners')));
const Partner = Loadable(lazy(() => import('views/admin-components/pages/Partner')));
const Fee = Loadable(lazy(() => import('views/admin-components/pages/Fee')));
const FeesReport = Loadable(lazy(() => import('views/admin-components/pages/FeesReport')));
const FeesType = Loadable(lazy(() => import('views/admin-components/pages/FeesType')));
const FeesTypes = Loadable(lazy(() => import('views/admin-components/pages/FeesTypes')));
const FeesRate = Loadable(lazy(() => import('views/admin-components/pages/FeesRate')));
const FeesRates = Loadable(lazy(() => import('views/admin-components/pages/FeesRates')));
const ProvinceRates = Loadable(lazy(() => import('views/admin-components/pages/ProvinceRates')));
const Faqs = Loadable(lazy(() => import('views/admin-components/pages/Faqs')));
const Faq = Loadable(lazy(() => import('views/admin-components/pages/Faq')));
const Questionnaire = Loadable(lazy(() => import('views/admin-components/pages/Questionnaire')));
const Questionnaires = Loadable(lazy(() => import('views/admin-components/pages/Questionnaires')));
const Referrals = Loadable(lazy(() => import('views/admin-components/pages/Referrals')));
const Newsletter = Loadable(lazy(() => import('views/admin-components/pages/Newsletters')));
// portfolio
const Portfolios = Loadable(lazy(() => import('views/admin-components/pages/Portfolios')));
const AddPortfolioSecurity = Loadable(lazy(() => import('views/admin-components/pages/Portfolios/AddPortfolioSecurity')));
const AddPortfolio = Loadable(lazy(() => import('views/admin-components/pages/Portfolios/AddPortfolio')));

// risk categories
const RiskCategories = Loadable(lazy(() => import('views/admin-components/pages/RiskCategories/RiskCategories')));
// const AddRiskCategorySecurity = Loadable(lazy(() => import('views/admin-components/pages/RiskCategories/AddPortfolioSecurity')));
const AddRiskCategory = Loadable(lazy(() => import('views/admin-components/pages/RiskCategories/AddRiskCategories')));
// const Users = Loadable(lazy(() => import('views/admin-components/pages/Users')));
const NonRegisterUsers = Loadable(lazy(() => import('views/admin-components/pages/NonRegisterUsers')));
const RegisterUsers = Loadable(lazy(() => import('views/admin-components/pages/RegisterUsers')));
const FundTransfer = Loadable(lazy(() => import('views/admin-components/pages/FundTransfer')));
const AdminFundTransfer = Loadable(lazy(() => import('views/admin-components/pages/AdminFundTransfer')));
const SmarterGroupCompany = Loadable(lazy(() => import('views/admin-components/pages/groupcompany/SmarterGroupCompany')));
const CompanyInformation = Loadable(lazy(() => import('views/admin-components/pages/groupcompany/CompanyInformation')));
const CompanyNotes = Loadable(lazy(() => import('views/admin-components/pages/groupcompany/CompanyNotes')));
const RemittanceDetails = Loadable(lazy(() => import('views/admin-components/pages/groupcompany/RemittanceDetails')));
const CompanyNoteModal = Loadable(lazy(() => import('views/admin-components/pages/groupcompany/CompanyNoteModal')));
const Rebalancer = Loadable(lazy(() => import('views/admin-components/pages/rebalancer/Rebalancer')));
const PendingRebalancers = Loadable(lazy(() => import('views/admin-components/pages/rebalancer/PendingRebalancers')));
const ReblancerAccountView = Loadable(lazy(() => import('views/admin-components/pages/rebalancer/ReblancerAccountView')));
const Withdrawal = Loadable(lazy(() => import('views/admin-components/pages/rebalancer/Withdrawal')));
const DeployCash = Loadable(lazy(() => import('views/admin-components/pages/rebalancer/DeployCash')));
const PendingTransaction = Loadable(lazy(() => import('views/admin-components/pages/rebalancer/PendingTransaction')));
const PendingWithdrawal = Loadable(lazy(() => import('views/admin-components/pages/rebalancer/PendingWithdrawal')));
const RebalancingRules = Loadable(lazy(() => import('views/admin-components/pages/rebalancer/RebalancingRules')));
const PendingTransactionNotes = Loadable(lazy(() => import('views/admin-components/pages/rebalancer/PendingTransactionNotes')));
const PendingWithdrawalNotes = Loadable(lazy(() => import('views/admin-components/pages/rebalancer/PendingWithdrawalNotes')));
const TradingQueue = Loadable(lazy(() => import('views/admin-components/pages/rebalancer/TradingQueue')));
const UserAccount = Loadable(lazy(() => import('views/admin-components/pages/useraccount/UserAccount')));
const UserAccountNote = Loadable(lazy(() => import('views/admin-components/pages/useraccount/UserAccountNote')));
const CiEfts = Loadable(lazy(() => import('views/admin-components/pages/CiEfts')));
const CiEft = Loadable(lazy(() => import('views/admin-components/pages/CiEft')));
const Notifications = Loadable(lazy(() => import('views/admin-components/pages/Notifications')));
const Notification = Loadable(lazy(() => import('views/admin-components/pages/Notification')));
const KycSummary = Loadable(lazy(() => import('views/admin-components/pages/KycTool/KycSummary/KycSummary')));
const KycSummaryNotes = Loadable(lazy(() => import('views/admin-components/pages/KycTool/KycSummary/KycSummaryNotes')));
const KycTimeline = Loadable(lazy(() => import('views/admin-components/pages/KycTool/KycSummary/KycTimeline')));
const KycSummaryAddNote = Loadable(lazy(() => import('views/admin-components/pages/KycTool/KycSummary/KycSummaryAddNote')));
const KycIssues = Loadable(lazy(() => import('views/admin-components/pages/KycTool/KycIssue/KycIssues')));
const KycIssueNote = Loadable(lazy(() => import('views/admin-components/pages/KycTool/KycIssue/KycIssueNote')));
const KycPersonal = Loadable(lazy(() => import('views/admin-components/pages/KycTool/KycPersonal/KycPersonal')));
const KycPersonalNote = Loadable(lazy(() => import('views/admin-components/pages/KycTool/KycPersonal/KycPersonalNote')));
const PortfolioManagers = Loadable(lazy(() => import('views/admin-components/pages/PortfolioManagers')));
const PortfolioManager = Loadable(lazy(() => import('views/admin-components/pages/PortfolioManager')));

const PortfolioManagersAssistant = Loadable(lazy(() => import('views/admin-components/pages/PortfolioManagersAssistant')));
const PortfolioManagerAssistant = Loadable(lazy(() => import('views/admin-components/pages/PortfolioManagerAssistant')));

const Admins = Loadable(lazy(() => import('views/admin-components/pages/Admins')));
const Admin = Loadable(lazy(() => import('views/admin-components/pages/Admin')));

const DailyCsv = Loadable(lazy(() => import('views/admin-components/pages/DailyCsv')));
const DailyCsvDetails = Loadable(lazy(() => import('views/admin-components/pages/DailyCsvDetails')));

const Roles = Loadable(lazy(() => import('views/admin-components/pages/Role-Permission/Roles')));
const Role = Loadable(lazy(() => import('views/admin-components/pages/Role-Permission/Role')));

const RoleRegistrationTypes = Loadable(lazy(() => import('views/admin-components/pages/Role-Permission/RoleRegistrationTypes')));
const RoleRegistrationType = Loadable(lazy(() => import('views/admin-components/pages/Role-Permission/RoleRegistrationType')));

const Permissions = Loadable(lazy(() => import('views/admin-components/pages/Role-Permission/Permissions')));
const Permission = Loadable(lazy(() => import('views/admin-components/pages/Role-Permission/Permission')));

const RolePermissions = Loadable(lazy(() => import('views/admin-components/pages/Role-Permission/RolePermissions')));
const RolePermission = Loadable(lazy(() => import('views/admin-components/pages/Role-Permission/RolePermission')));
const ClientTransaction = Loadable(lazy(() => import('views/admin-components/pages/admin-client-form/ClientTransaction')));
const RiskAssessment = Loadable(lazy(() => import('views/admin-components/pages/admin-client-form/RiskAssessment')));
const FidelityAccounts = Loadable(lazy(() => import('views/admin-components/pages/fidelity-accounts/FidelityAccounts')));
const AgreementDocs = Loadable(lazy(() => import('views/admin-components/pages/AgreementDocs')));
const UserAgreementDetails = Loadable(lazy(() => import('views/admin-components/pages/UserAgreementDetails')));
const HouseHoldList = Loadable(lazy(() => import('views/admin-components/pages/HouseHoldList')));
const Household = Loadable(lazy(() => import('views/admin-components/pages/Household')));
const AumSummary = Loadable(lazy(() => import('views/common-components/aum-summary/AumSummary')));
const ClientNotes = Loadable(lazy(() => import('views/admin-components/pages/admin-client-form/ClientNotes.jsx')));

const loginType = localStorage.getItem('login_type');

const storedPermissions = localStorage.getItem('manager_permissions');
const parsedPermissions = storedPermissions ? JSON.parse(storedPermissions) : null;
const isAdminLogin = (loginType === 'portfolio_manager_admin' || loginType === 'admin') && parsedPermissions ? true : false;
// const dashboardLogin = localStorage.getItem('dashboard_login') === 'true';
const hasPermission = (permissionName) => Object.prototype.hasOwnProperty.call(parsedPermissions || {}, permissionName);
const canAccess = (permissionName) => isAdminLogin && hasPermission(permissionName);

const permissionRoutePatterns = [
    { permission: 'Asset Category', paths: ['/asset-categories', '/asset-category'] },
    { permission: 'Asset Class', paths: ['/asset-classes', '/asset-class'] },
    { permission: 'Portfolio', paths: ['/portfolios', '/add-portfolio'] },
    { permission: 'Risk Categories', paths: ['/risk-categories', '/add-risk-category'] },
    { permission: 'Security', paths: ['/securities', '/security'] },
    { permission: 'Questionnaire', paths: ['/questionnaires', '/questionnaire'] },
    { permission: 'Add Fund', paths: ['/add-funds', '/add-fund'] },
    { permission: 'Enhancement Fund', paths: ['/enhancements', '/add-enhancement'] },
    { permission: 'Benchmark', paths: ['/benchmarks', '/add-benchmark'] },
    { permission: 'Rebalancer', paths: ['/rebalancers', '/rebalancer-account-view', '/withdrawal', '/deploy-cash'] },
    { permission: 'Trading Queue', paths: ['/trading-queue'] },
    { permission: 'Pending Trade', paths: ['/pending-transaction', '/pending-transaction-notes'] },
    { permission: 'Pending Withdrawals', paths: ['/pending-withdrawal', '/pending-withdrawal-notes'] },
    { permission: 'Pending Rebalancers', paths: ['/pending-rebalancer'] },
    { permission: 'Rebalancer Rules', paths: ['/rebalancing-rules'] },
    { permission: 'Fund Transfer', paths: ['/fund-transfer'] },
    { permission: 'Advisors', paths: ['/advisors', '/advisor'] },
    { permission: 'Referral', paths: ['/referrals'] },
    { permission: 'Onboarding', paths: ['/non-register'] },
    { permission: 'Clients', paths: ['/register'] },
    { permission: 'User Agreement Details', paths: ['/user-agreement-details'] },
    { permission: 'Household', paths: ['/household-list', '/household'] },
    { permission: 'Compliance Summary', paths: ['/kyc-summary'] },
    { permission: 'Issues', paths: ['/kyc-issues', '/kyc-issue-note'] },
    { permission: 'Personal Notes', paths: ['/kyc-personal', '/kyc-personal-note'] },
    { permission: 'Registration Type', paths: ['/role-registration-types', '/role-registration-type'] },
    { permission: 'Role', paths: ['/roles', '/role'] },
    { permission: 'Permission', paths: ['/permissions', '/permission'] },
    { permission: 'Role & Permission', paths: ['/role-permissions', '/role-permission'] },
    { permission: 'Bulk Upload', paths: ['/bulk-upload'] },
    { permission: 'Portfolio Manager', paths: ['/portfolio-managers', '/portfolio-manager'] },
    { permission: 'Fees', paths: ['/fee-report', '/fee'] },
    { permission: 'Fees Type', paths: ['/fees-types', '/fees-type'] },
    { permission: 'Fees Rate', paths: ['/fees-rates', '/fees-rate'] },
    { permission: 'Province Rate', paths: ['/province-rate'] },
    { permission: 'Add Admin', paths: ['/admins', '/add-admin', '/edit-admin'] }
];

const matchesRoutePattern = (routePath, pattern) => (
    routePath === pattern || routePath.startsWith(`${pattern}/`)
);

const AdminPermissionRoute = ({ children }) => {
    const location = useLocation();
    const routePath = location.pathname.replace(/^\/admin/, '') || '/';
    const protectedRoute = permissionRoutePatterns.find(({ paths }) => (
        paths.some((pattern) => matchesRoutePattern(routePath, pattern))
    ));

    if (!protectedRoute || hasPermission(protectedRoute.permission)) {
        return children;
    }

    return <Navigate to={'/admin/non-register'} replace />;
};

const AdminRoute = {
    path: '/',
    element: isAdminLogin ? (
        <AdminPermissionRoute>
            <MainLayout />
        </AdminPermissionRoute>
    ) : <Navigate to={'/admin'} />,
    children: [

        { path: '/admin/client-form/:id', element: isAdminLogin ? <ClientFormSteps /> : <Navigate to={'/admin'} /> },
        { path: '/admin/client-transaction/:id', element: isAdminLogin ? <ClientTransaction /> : <Navigate to={'/admin'} /> },
        { path: '/admin/risk-assessment/:id', element: isAdminLogin ? <RiskAssessment /> : <Navigate to={'/admin'} /> },
        // -------------ASSET CATEGORY---------------//
        { path: '/admin/asset-categories', element: isAdminLogin ? <AssetCategories /> : <Navigate to={'/admin'} /> },
        { path: '/admin/asset-category/:id', element: isAdminLogin ? <AssetCategory /> : <Navigate to={'/admin'} /> },
        { path: '/admin/asset-category', element: isAdminLogin ? <AssetCategory /> : <Navigate to={'/admin'} /> },

        // -------------ASSET CLASS---------------//
        { path: '/admin/asset-classes', element: isAdminLogin ? <AssetClasses /> : <Navigate to={'/admin'} /> },
        { path: '/admin/asset-class', element: isAdminLogin ? <AssetClass /> : <Navigate to={'/admin'} /> },
        { path: '/admin/asset-class/:id', element: isAdminLogin ? <AssetClass /> : <Navigate to={'/admin'} /> },

        // --------------SECURITY---------------//
        { path: '/admin/securities', element: isAdminLogin ? <Securities /> : <Navigate to={'/admin'} /> },
        { path: '/admin/security', element: isAdminLogin ? <Security /> : <Navigate to={'/admin'} /> },
        { path: '/admin/security/:id', element: isAdminLogin ? <Security /> : <Navigate to={'/admin'} /> },

        // --------------Funds---------------//
        { path: '/admin/add-funds', element: isAdminLogin ? <AddFunds /> : <Navigate to={'/admin'} /> },
        { path: '/admin/add-fund', element: isAdminLogin ? <AddFund /> : <Navigate to={'/admin'} /> },
        { path: '/admin/add-fund/:id', element: isAdminLogin ? <AddFund /> : <Navigate to={'/admin'} /> },

        // --------------Benchmark---------------//
        { path: '/admin/benchmarks', element: isAdminLogin ? <Benchmarks /> : <Navigate to={'/admin'} /> },
        { path: '/admin/add-benchmark', element: isAdminLogin ? <Benchmark /> : <Navigate to={'/admin'} /> },
        { path: '/admin/add-benchmark/:id', element: isAdminLogin ? <Benchmark /> : <Navigate to={'/admin'} /> },

        // --------------enhancements fund---------------//
        { path: '/admin/enhancements', element: isAdminLogin ? <Enhancements /> : <Navigate to={'/admin'} /> },
        // { path: '/admin/add-enhancement', element: isAdminLogin ? <Enhancement /> : <Navigate to={'/admin'} /> },
        { path: '/admin/add-enhancement/:portfolio_type_id/:mode/:type', element: isAdminLogin ? <Enhancement /> : <Navigate to={'/admin'} /> },

        // --------------ACCOUNT TYPES---------------//
        // { path: '/admin/account-types', element: isAdminLogin ? <AccountTypes /> : <Navigate to={'/admin'} /> },
        // { path: '/admin/account-type', element: isAdminLogin ? <AccountType /> : <Navigate to={'/admin'} /> },
        // { path: '/admin/account-type/:id', element: isAdminLogin ? <AccountType /> : <Navigate to={'/admin'} /> },

        // --------------PARTNERS---------------//
        { path: '/admin/partners', element: isAdminLogin ? <Partners /> : <Navigate to={'/admin'} /> },
        { path: '/admin/partner', element: isAdminLogin ? <Partner /> : <Navigate to={'/admin'} /> },
        { path: '/admin/partner/:id', element: isAdminLogin ? <Partner /> : <Navigate to={'/admin'} /> },

        // --------------ADVISOR---------------//
        { path: '/admin/advisors', element: isAdminLogin ? <Advisors /> : <Navigate to={'/admin'} /> },
        { path: '/admin/advisor', element: isAdminLogin ? <Advisor /> : <Navigate to={'/admin'} /> },
        { path: '/admin/advisor/:id', element: isAdminLogin ? <Advisor /> : <Navigate to={'/admin'} /> },

        // --------------FEES---------------//
        { path: '/admin/fee-report', element: canAccess('Fees') ? <FeesReport /> : <Navigate to={'/admin/non-register'} /> },
        { path: '/admin/fee', element: canAccess('Fees') ? <Fee /> : <Navigate to={'/admin/non-register'} /> },
        { path: '/admin/fee/:id', element: canAccess('Fees') ? <Fee /> : <Navigate to={'/admin/non-register'} /> },

        // --------------FEES TYPES---------------//
        { path: '/admin/fees-types', element: canAccess('Fees Type') ? <FeesTypes /> : <Navigate to={'/admin/non-register'} /> },
        { path: '/admin/fees-type', element: canAccess('Fees Type') ? <FeesType /> : <Navigate to={'/admin/non-register'} /> },
        { path: '/admin/fees-type/:id', element: canAccess('Fees Type') ? <FeesType /> : <Navigate to={'/admin/non-register'} /> },

        // --------------FEES RATES---------------//
        { path: '/admin/fees-rates', element: canAccess('Fees Rate') ? <FeesRates /> : <Navigate to={'/admin/non-register'} /> },
        { path: '/admin/fees-rate', element: canAccess('Fees Rate') ? <FeesRate /> : <Navigate to={'/admin/non-register'} /> },
        { path: '/admin/fees-rate/:id', element: canAccess('Fees Rate') ? <FeesRate /> : <Navigate to={'/admin/non-register'} /> },

        { path: '/admin/province-rate', element: canAccess('Province Rate') ? <ProvinceRates /> : <Navigate to={'/admin/non-register'} /> },

        // --------------FAQs---------------//
        { path: '/admin/faqs', element: isAdminLogin ? <Faqs /> : <Navigate to={'/admin'} /> },
        { path: '/admin/faq', element: isAdminLogin ? <Faq /> : <Navigate to={'/admin'} /> },
        { path: '/admin/faq/:id', element: isAdminLogin ? <Faq /> : <Navigate to={'/admin'} /> },

        // --------------QUESTIONNAIRES---------------//
        { path: '/admin/questionnaires', element: isAdminLogin ? <Questionnaires /> : <Navigate to={'/admin'} /> },
        { path: '/admin/questionnaire/:portfolio_manager_id/:super_admin_id', element: isAdminLogin ? <Questionnaire /> : <Navigate to={'/admin'} /> },
        { path: '/admin/questionnaire/:portfolio_manager_id/:super_admin_id/:question_id', element: isAdminLogin ? <Questionnaire /> : <Navigate to={'/admin'} /> },

        // --------------REFERRALS---------------//
        { path: '/admin/referrals', element: isAdminLogin ? <Referrals /> : <Navigate to={'/admin'} /> },

        // --------------NEWSLETTER---------------//
        { path: '/admin/newsletters', element: isAdminLogin ? <Newsletter /> : <Navigate to={'/admin'} /> },

        // --------------PORTFOLIO---------------//
        { path: '/admin/portfolios', element: isAdminLogin ? <Portfolios /> : <Navigate to={'/admin'} /> },
        { path: '/admin/add-portfolio-security', element: isAdminLogin ? <AddPortfolioSecurity /> : <Navigate to={'/admin'} /> },
        { path: '/admin/add-portfolio/:id/:addEditId', element: isAdminLogin ? <AddPortfolio /> : <Navigate to={'/admin'} /> },

        // --------------risk-categories---------------//
        { path: '/admin/risk-categories', element: isAdminLogin ? <RiskCategories /> : <Navigate to={'/admin'} /> },
        // { path: '/admin/add-risk-category-security', element: isAdminLogin ? <AddRiskCategorySecurity /> : <Navigate to={'/admin'} /> },
        { path: '/admin/add-risk-category', element: isAdminLogin ? <AddRiskCategory /> : <Navigate to={'/admin'} /> },
        { path: '/admin/add-risk-category/:id', element: isAdminLogin ? <AddRiskCategory /> : <Navigate to={'/admin'} /> },

        { path: '/admin/portfolio-managers', element: canAccess('Portfolio Manager') ? <PortfolioManagers /> : <Navigate to={'/admin/non-register'} /> },
        { path: '/admin/portfolio-manager', element: canAccess('Portfolio Manager') ? <PortfolioManager /> : <Navigate to={'/admin/non-register'} /> },
        { path: '/admin/portfolio-manager/:id', element: canAccess('Portfolio Manager') ? <PortfolioManager /> : <Navigate to={'/admin/non-register'} /> },

        { path: '/admin/portfolio-manager-assistants', element: isAdminLogin ? <PortfolioManagersAssistant /> : <Navigate to={'/admin'} /> },
        { path: '/admin/portfolio-manager-assistant', element: isAdminLogin ? <PortfolioManagerAssistant /> : <Navigate to={'/admin'} /> },
        { path: '/admin/portfolio-manager-assistant/:id', element: isAdminLogin ? <PortfolioManagerAssistant /> : <Navigate to={'/admin'} /> },

        // { path: '/admin/users', element: isAdminLogin ? <Users /> : <Navigate to={'/admin'} /> },
        { path: '/admin/register', element: isAdminLogin ? <RegisterUsers /> : <Navigate to={'/admin'} /> },
        { path: '/admin/non-register', element: isAdminLogin ? <NonRegisterUsers /> : <Navigate to={'/admin'} /> },

        { path: '/admin/household-list', element: isAdminLogin ? <HouseHoldList /> : <Navigate to={'/admin'} /> },
        { path: '/admin/household', element: isAdminLogin ? <Household /> : <Navigate to={'/admin'} /> },
        { path: '/admin/household/:id', element: isAdminLogin ? <Household /> : <Navigate to={'/admin'} /> },

        // --------------FUND TRANSFER---------------//
        { path: '/admin/fund-transfer', element: isAdminLogin ? <FundTransfer /> : <Navigate to={'/admin'} /> },
        { path: '/admin/admin-fund-transfer', element: isAdminLogin ? <AdminFundTransfer /> : <Navigate to={'/admin'} /> },

        // --------------SMARTER GROUP COMPANY---------------//
        { path: '/admin/smarter-group-company', element: isAdminLogin ? <SmarterGroupCompany /> : <Navigate to={'/admin'} /> },
        { path: '/admin/company-information/:companyId', element: isAdminLogin ? <CompanyInformation /> : <Navigate to={'/admin'} /> },
        //  path="/to/page/:pathParam1?/:pathParam2?" component={MyPage} />  // OPTIONAL PARAMS
        { path: '/admin/company-information/register/3', element: isAdminLogin ? <CompanyInformation /> : <Navigate to={'/admin'} /> },
        { path: '/admin/company-notes/:companyId', element: isAdminLogin ? <CompanyNotes /> : <Navigate to={'/admin'} /> },
        { path: '/admin/remittance-details/:companyId', element: isAdminLogin ? <RemittanceDetails /> : <Navigate to={'/admin'} /> },
        { path: '/admin/company-note-modal/:companyId', element: isAdminLogin ? <CompanyNoteModal /> : <Navigate to={'/admin'} /> },
        { path: '/admin/rebalancers', element: isAdminLogin ? <Rebalancer /> : <Navigate to={'/admin'} /> },
        { path: '/admin/rebalancer-account-view/:userId/:accountNumber', element: isAdminLogin ? <ReblancerAccountView /> : <Navigate to={'/admin'} /> },
        { path: '/admin/rebalancing-rules', element: isAdminLogin ? <RebalancingRules /> : <Navigate to={'/admin'} /> },
        { path: '/admin/withdrawal/:userId/:accountNumber', element: isAdminLogin ? <Withdrawal /> : <Navigate to={'/admin'} /> },
        { path: '/admin/deploy-cash/:userId/:accountNumber', element: isAdminLogin ? <DeployCash /> : <Navigate to={'/admin'} /> },
        { path: '/admin/pending-transaction', element: isAdminLogin ? <PendingTransaction /> : <Navigate to={'/admin'} /> },
        { path: '/admin/pending-withdrawal', element: isAdminLogin ? <PendingWithdrawal /> : <Navigate to={'/admin'} /> },
        { path: '/admin/pending-transaction-notes/:userId', element: isAdminLogin ? <PendingTransactionNotes /> : <Navigate to={'/admin'} /> },
        { path: '/admin/pending-withdrawal-notes/:userId', element: isAdminLogin ? <PendingWithdrawalNotes /> : <Navigate to={'/admin'} /> },
        { path: '/admin/pending-rebalancer', element: isAdminLogin ? <PendingRebalancers /> : <Navigate to={'/admin'} /> },
        { path: '/admin/trading-queue', element: isAdminLogin ? <TradingQueue /> : <Navigate to={'/admin'} /> },
        { path: '/admin/user-account', element: isAdminLogin ? <UserAccount /> : <Navigate to={'/admin'} /> },
        { path: '/admin/user-account-notes/:userId', element: isAdminLogin ? <UserAccountNote /> : <Navigate to={'/admin'} /> },
        { path: '/admin/ci-efts', element: isAdminLogin ? <CiEfts /> : <Navigate to={'/admin'} /> },
        { path: '/admin/ci-eft', element: isAdminLogin ? <CiEft /> : <Navigate to={'/admin'} /> },
        { path: '/admin/ci-eft/:id', element: isAdminLogin ? <CiEft /> : <Navigate to={'/admin'} /> },
        // { path: '/admin/ci-eft/:id', element: isAdminLogin ? <CiEft /> : <Navigate to={'/admin'} /> },
        { path: '/admin/notifications', element: isAdminLogin ? <Notifications /> : <Navigate to={'/admin'} /> },
        { path: '/admin/notification', element: isAdminLogin ? <Notification /> : <Navigate to={'/admin'} /> },
        { path: '/admin/notification/:notificationId', element: isAdminLogin ? <Notification /> : <Navigate to={'/admin'} /> },
        { path: '/admin/kyc-summary', element: isAdminLogin ? <KycSummary /> : <Navigate to={'/admin'} /> },
        { path: '/admin/kyc-notes/:id', element: isAdminLogin ? <KycSummaryNotes /> : <Navigate to={'/admin'} /> },
        { path: '/admin/add-kyc-note/:id', element: isAdminLogin ? <KycSummaryAddNote /> : <Navigate to={'/admin'} /> },
        { path: '/admin/kyc-timeline/:id', element: isAdminLogin ? <KycTimeline /> : <Navigate to={'/admin'} /> },
        { path: '/admin/kyc-issues', element: isAdminLogin ? <KycIssues /> : <Navigate to={'/admin'} /> },
        { path: '/admin/kyc-issue-note/:id', element: isAdminLogin ? <KycIssueNote /> : <Navigate to={'/admin'} /> },

        { path: '/admin/kyc-personal', element: isAdminLogin ? <KycPersonal /> : <Navigate to={'/admin'} /> },
        { path: '/admin/kyc-personal-note/:id', element: isAdminLogin ? <KycPersonalNote /> : <Navigate to={'/admin'} /> },
        // { path: '/admin/add-kyc-personal-note:/id', element: isAdminLogin ? <KycPersonalAddNote /> : <Navigate to={'/admin'} /> },


        // --------------ADD ADMIN---------------//
        { path: '/admin/admins', element: canAccess('Add Admin') ? <Admins /> : <Navigate to={'/admin/non-register'} /> },
        { path: '/admin/add-admin', element: canAccess('Add Admin') ? <Admin /> : <Navigate to={'/admin/non-register'} /> },
        { path: '/admin/edit-admin/:id', element: canAccess('Add Admin') ? <Admin /> : <Navigate to={'/admin/non-register'} /> },

        // --------------DAILY CSV---------------//
        { path: '/admin/daily-csv', element: isAdminLogin ? <DailyCsv /> : <Navigate to={'/admin'} /> },
        { path: '/admin/daily-csv-details', element: isAdminLogin ? <DailyCsvDetails /> : <Navigate to={'/admin'} /> },
        { path: '/admin/daily-csv-details/:id', element: isAdminLogin ? <DailyCsvDetails /> : <Navigate to={'/admin'} /> },


        // --------------ROLE & PERMISSION---------------//

        { path: '/admin/roles', element: isAdminLogin ? <Roles /> : <Navigate to={'/admin'} /> },
        { path: '/admin/role', element: isAdminLogin ? <Role /> : <Navigate to={'/admin'} /> },
        { path: '/admin/role/:id', element: isAdminLogin ? <Role /> : <Navigate to={'/admin'} /> },

        { path: '/admin/role-registration-types', element: isAdminLogin ? <RoleRegistrationTypes /> : <Navigate to={'/admin'} /> },
        { path: '/admin/role-registration-type', element: isAdminLogin ? <RoleRegistrationType /> : <Navigate to={'/admin'} /> },
        { path: '/admin/role-registration-type/:id', element: isAdminLogin ? <RoleRegistrationType /> : <Navigate to={'/admin'} /> },

        { path: '/admin/permissions', element: isAdminLogin ? <Permissions /> : <Navigate to={'/admin'} /> },
        { path: '/admin/permission', element: isAdminLogin ? <Permission /> : <Navigate to={'/admin'} /> },
        { path: '/admin/permission/:id', element: isAdminLogin ? <Permission /> : <Navigate to={'/admin'} /> },

        { path: '/admin/role-permissions', element: isAdminLogin ? <RolePermissions /> : <Navigate to={'/admin'} /> },
        { path: '/admin/role-permission', element: isAdminLogin ? <RolePermission /> : <Navigate to={'/admin'} /> },
        { path: '/admin/role-permission/:id', element: isAdminLogin ? <RolePermission /> : <Navigate to={'/admin'} /> },


        { path: '/admin/bulk-upload', element: isAdminLogin ? <FidelityAccounts /> : <Navigate to={'/admin'} /> },
        { path: '/admin/client-agreement', element: isAdminLogin ? <FidelityAccounts /> : <Navigate to={'/admin'} /> },
        { path: '/admin/agreement-docs/:id', element: isAdminLogin ? <AgreementDocs /> : <Navigate to={'/admin'} /> },


        { path: '/admin/user-agreement-details', element: isAdminLogin ? <UserAgreementDetails /> : <Navigate to={'/admin'} /> },
        { path: '/admin/aum-summary', element: isAdminLogin ? <AumSummary /> : <Navigate to={'/admin'} /> },

         { path: '/admin/client-notes/:userId', element: isAdminLogin ? <ClientNotes /> : <Navigate to={'/admin'} />},

        // --------------------TEST-----------------------//
        // { path: '/smartmoney/test', element: isAdminLogin ? <Test /> : <Navigate to={'/admin'} /> },

        { path: '*', element: <NotFound /> }
    ]
};


function NotFound() {
    return (
        <>
            <h4>Not Found</h4>
        </>
    )
}
export default AdminRoute;
